<div class="balance-box shimmers-wrapper">
  <h3 class="shimmer shimmer2y"></h3>
  <p class="shimmer"></p>
</div>
